import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { buildFleetQuery } from '../_shared/utils/fleet-query';

@Injectable({
  providedIn: 'root'
})
export class FleetGeneralFigureService {

  constructor(private readonly httpClient: HttpClient) { }

  getSohcFleet(fleetId: string[], batteryType?: string[]): Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'soh-fleet?' + buildFleetQuery(fleetId, batteryType));
  }

  getPredictedSohcFleet(fleetId: string[], batteryType?: string[]): Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'predicted-sohc-fleet?' + buildFleetQuery(fleetId, batteryType));
  }

  getMileageFleet(fleetId: string[], batteryType?: string[]): Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'mileage-fleet?' + buildFleetQuery(fleetId, batteryType));
  }

  getEnergyEfficiencyFleet(fleetId: string[], batteryType?: string[]): Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'energy-efficiency-fleet?' + buildFleetQuery(fleetId, batteryType));
  }

  getBatteryConditionFleet(fleetId: string[], batteryType?: string[]): Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'battery-condition-fleet?' + buildFleetQuery(fleetId, batteryType));
  }

  getStressFactorsFleet(fleetId: string[], batteryType?: string[]):Observable<any> {
    return this.httpClient.get<any[]>(environment.apiEndpoint + 'stress-factors-fleet?' + buildFleetQuery(fleetId, batteryType));
  }

  getReferenceFleet():Observable<any> {
    return this.httpClient.get<any[]>(environment.apiEndpoint + 'reference-fleet');
  }

  getAtomicAgingFleet(fleetId: string[], batteryType?: string[]): Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'v2/stress-factors-fleet?' + buildFleetQuery(fleetId, batteryType));
  }
}
